<template>
  <div
    class="litops orangeToYellow"
    :class="(info.type == 2 || info.type === 1) && 'display-flex'"
  >
    <div class="litop1">
      <div class="litop1_left ellipsis" @click="showEquiment">
        <div class="deviceName ellipsis">{{ info.deviceName }}</div>
        <i class="iconfont icon-xiala"></i>
        <span v-show="info.type !== 2" :class="online ? 'online' : 'offline'">
          {{
            online === '' ? '' : online ? $t('live.online') : $t('live.offline')
          }}
        </span>
      </div>
      <div
        style="position: absolute; right: 10px; top: 10px; font-size: 12px;"
        v-if="info.type == 2 || info.type === 1"
      >
        {{ cgqInfo.retime }}
      </div>
    </div>
    <div class="litop2 fs24">
      <!-- 轮灌组入口 -->
      <span
        class="lunguan"
        v-if="info.type === 4 || info.type === 6"
        @click="handleLunguan"
      >
        <span>
          <img src="./../../../assets/images/water_drop.png" alt="" />
        </span>
        <span>程序</span>
      </span>
      <span class="txt" v-if="info.type !== 4 && info.type !== 6">
        {{ $t('live.code') }}：{{ info.no }}
      </span>

      <span class="txt" v-if="type === 1 || type === 2">
        {{ $t('live.voltage') }}：{{ cgqInfo.voltage }}v
        <img
          v-if="cgqInfo.solarVoltage"
          src="../../../assets/images/battery.png"
          class="battery"
        />
      </span>
    </div>

    <!-- RTU设备可以横向和卡片模式 -->
    <div class="card-icon">
      <van-icon
        @click="handleIcon('list')"
        name="apps-o"
        v-if="type === 6 && cardType === 'card'"
      />
      <van-icon
        @click="handleIcon('card')"
        name="wap-nav"
        v-else-if="type === 6 && cardType === 'list'"
      />

      <!-- <van-icon name="paid" @click="handleIcon('card')" v-else-if="type === 7" /> -->

      <!-- 查看二代气象站设备的信息 -->
      <!-- 二代气象站也可以看设备属性 能拍照 -->
      <van-icon
        @click="handleCamera"
        name="column"
        class="test"
        v-else-if="type === 7"
      />
      <!-- 一代气象站也可以看设备属性 但是不能拍照 -->
      <van-icon
        @click="handleCamera"
        name="column"
        class="test2"
        v-if="type === 2 || type === 6"
      />
      <!-- 查看设备日志 -->
      <van-icon
        @click="hadnleToGatewayLog"
        name="todo-list-o"
        v-if="type === 4"
      />
    </div>

    <!-- 4 6 采集器和解码器设备 设备编号换一行 上面放轮灌组 -->
    <div class="deviceNo fs24" v-if="info.type === 4 || info.type === 6">
      <span class="txt">{{ $t('live.code') }}：{{ info.no }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: {} | '' | null,
    },
    showEquiment: {
      type: Function,
      default: () => {},
    },
    online: {
      type: 'online' | 'offline',
      default: 'offline',
    },
    cgqInfo: {
      type: Object,
      default: {},
    },
    cardTriger: {
      type: Function,
      default: () => {},
    },
  },

  computed: {
    // showLog() {
    //   // const host = window.location.host
    //   return this.type === 4
    // },
  },

  watch: {
    info(v) {
      this.type = v.type
      console.log('this.type:', this.type)
    },

    cgqInfo(v) {
      console.log('传感器相关信息:', v, this.info.type)
    },
  },

  data() {
    return {
      type: null,
      cardType: 'card',
    }
  },

  methods: {
    // 去阀门登录日志页面
    hadnleToGatewayLog() {
      this.$router.push('/gatewayLog')
    },

    handleIcon(cardType) {
      this.cardType = cardType
      this.cardTriger(cardType)
      // this.$emit("cardTriger", cardType);
    },

    handleLunguan() {
      sessionStorage.setItem('deviceType', this.info.type)
      this.$router.push('/lunguan')
    },

    handleCamera() {
      this.$router.push(`/camera?type=${this.type}`)
    },
  },
}
</script>

<style lang="scss" scoped>
.litops {
  width: 100%;
  overflow: hidden;
  z-index: 2;
  padding: 10px;
  box-sizing: border-box;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.3);
}

.litop1,
.litop2 {
  display: inline-block !important;
}

.display-flex {
  .litop1 {
    display: flex;
    width: 100%;
  }

  .litop2 {
    // display: block !important;
  }
}

.litop1 {
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  color: #ffffff;
  line-height: 30px;
  width: 45%;
  height: 30px;
  margin-right: 10px;
}

.litop1 .litop1_left {
  display: flex;
  justify-content: space-between;
  position: relative;
  max-width: 200px;
  font-size: 18px;
  font-weight: 700;
}

.litop1 .litop1_left i {
  opacity: 0.5;
  position: relative;
  left: -2px;
}

.litop1 .litop1_left i.icon-xiala {
  font-size: 14px;
  padding: 0 5px;
}

.litop1 .litop1_left i.icon-lixian {
  font-size: 20px;
  color: black;
}

.litop1 .litop1_right {
  float: right;
  font-size: 12px;
  opacity: 0.4;
}

.litop1 .litop1_right img {
  width: 18px;
  height: 18px;
  margin-left: 0.15rem;
}

.online {
  font-size: 13px;
  color: #08ec08;
}

.offline {
  font-size: 13px;
  color: red;
}

.deviceName {
  // max-width: 100px;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  font-size: 14px;
}

.litop2 {
  text-align: left;
  color: #c5d3f4;
  font-weight: bold;
  overflow: hidden;
  line-height: 30px;
}

.litop2 span img {
  width: 0.25rem;
  height: 0.19rem;
  vertical-align: middle;
  margin-top: -0.08rem;
}

.litop2 .txt6 {
  display: inline-block;
  height: 0.6rem;
  line-height: 0.6rem;
  background: #2b5dd8;
  border-radius: 0.1rem;
  padding-right: 0;
  padding: 0 8px;
  text-align: center;
  float: right;
  margin: 0rem 0rem 0 0;
  color: #ffffff;
}

.litop2 .txt6 a {
  color: #ffffff;
}

.litop2 .txt6 {
  background: #05a405;
}
.txt {
  font-size: 14px;
  font-weight: normal;
  margin-right: 10px;
}

.txt:last-child {
  margin-right: 0;
}

.card-icon {
  display: flex;
  justify-content: space-between;
  float: right;
  color: #ffffff;
  margin-top: 4px;

  /deep/ .van-icon {
    font-size: 20px;
  }
}

.test2 {
  margin: 0 10px;
}

.lunguan {
  // float: right;
  // display: flex;
  align-items: center;
  color: #ffffff;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  border: 1px solid #ffffff;
  border-radius: 16px;
  padding: 0 6px;

  img {
    width: 9px !important;
    height: 12px !important;
    margin-right: 4px;
  }
}

.deviceNo {
  color: #ffffff;
}
</style>
